export default "__VITE_ASSET__DuuyCuel__"